import React from 'react'

import AddBuyerCategoryForm from '../../modules/BuyerCategory/components/AddBuyerCategoryForm'
export default function AddBuyerCategoryPage() {
  return <AddBuyerCategoryForm />
}
